Auth = require 'app/scripts/db/auth'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

flagId = 'growth.trello-jsw-crossflow-touchpoint-experiment-v1'
defaultFlagValue = 'not-enrolled'

isEnrolledInJSWCrossflowWithoutFiringFeatureExposedEvent = ->
  cohort = featureFlagClient.get flagId, defaultFlagValue
  return cohort == 'Variation_Targeted'

isControlOrEnrolledInJSWCrossflowWithoutFiringFeatureExposedEvent = ->
  cohort = featureFlagClient.get flagId, defaultFlagValue
  return cohort == 'Control_NoTarget' || cohort == 'Variation_Targeted'

isEnrolledInJSWCrossflow = (touchPoint) ->
  cohort = featureFlagClient.get flagId, defaultFlagValue
  if cohort != defaultFlagValue
    # calling getTrackedVariation so that an exposure event will be triggered
    featureFlagClient.getTrackedVariation(
      flagId,
      defaultFlagValue,
      { touchPoint }
    )
  return cohort == 'Variation_Targeted'

module.exports = {
  isControlOrEnrolledInJSWCrossflowWithoutFiringFeatureExposedEvent,
  isEnrolledInJSWCrossflowWithoutFiringFeatureExposedEvent,
  # checks the exclusion criteria and returns whether we should show the board popover touchpoint
  isBoardActive: ->
    !Auth.me().isDismissed('jsw-crossflow-popover') and
    isEnrolledInJSWCrossflow('board')

  isAtlassianSwitcherActive: ->
    isEnrolledInJSWCrossflow('switcher')

  isPowerUpStoreActive: ->
    isEnrolledInJSWCrossflow('powerUpsStore')
}
